import script from "./SuperadminAuditView.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperadminAuditView.vue?vue&type=script&setup=true&lang=js"

import "./SuperadminAuditView.vue?vue&type=style&index=0&id=57b9298a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57b9298a"]])

export default __exports__